const titles = document.querySelectorAll('.sidebar__title');

if (titles) {
    titles.forEach(item => {
        item.addEventListener('click', (e) => {
            if (window.innerWidth < 640) {
                e.currentTarget.classList.toggle('active');
            }
        });
    });
}